import options from './options';
import fieldNames from './field-names';
import orderDirections from './order-directions';

export default {
  [options.NAME_ASC]: { field: fieldNames.NAME, direction: orderDirections.ASC },
  [options.NAME_DESC]: { field: fieldNames.NAME, direction: orderDirections.DESC },
  [options.DATE_ASC]: { field: fieldNames.DATE, direction: orderDirections.ASC },
  [options.DATE_DESC]: { field: fieldNames.DATE, direction: orderDirections.DESC }
};